/**
 * Fetches and parses a /general/batch file (OWA-1378).
 *
 * The body is read once with response.text() and parsed. The previous loader kept every chunk,
 * copied them into one buffer and decoded that, so each file existed three or four times over.
 * Files still load in parallel, and parsing stays on the main thread: a worker, or loading one
 * file at a time, lowered the longest block but made the whole load up to twice as slow.
 *
 * @param {string} url - the file to fetch (CORS GET)
 * @param {AbortSignal} [signal] - aborts the load
 * @returns {Promise<any>} - the parsed JSON, or the text of a non-JSON response; malformed JSON rejects
 */
export async function loadJsonFile(url: string, signal?: AbortSignal): Promise<any> {
    const response = await fetch(url, {method: 'GET', mode: 'cors', signal});
    if (!response.ok) throw Error(`Fetch failed. ${response.status} - ${response.statusText}`);
    // Chromium and Firefox report an aborted body as a network error; prefer the abort reason
    const text = await response.text().catch(err => {
        signal?.throwIfAborted();
        throw err;
    });
    signal?.throwIfAborted();
    return response.headers.get('content-type')?.includes('application/json') ? JSON.parse(text) : text;
}
